import type { FindingGroupDisplay } from '../../types/reportDetail';
import styles from './FindingsSection.module.css';

interface FindingsSectionProps {
  groups: FindingGroupDisplay[];
}

function FindingGroup({ group }: { group: FindingGroupDisplay }) {
  const visibleItems = group.items.filter((item) => item.value);
  const isSplit = group.style === 'SPLIT';

  return (
    <div className={styles.group}>
      <div className={styles.groupHeader}>
        <div className={styles.accentBar} />
        <span className={styles.groupTitle}>{group.groupLabel}</span>
      </div>
      <div className={styles.groupContent}>
        {visibleItems.map((item) => (
          <div
            key={item.key}
            className={isSplit ? styles.itemSplit : styles.item}
          >
            {isSplit && <span className={styles.itemLabel}>{item.label}</span>}
            <span className={styles.itemValue}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function FindingsSection({ groups }: FindingsSectionProps) {
  const nonEmptyGroups = groups.filter((g) =>
    g.items.some((item) => item.value)
  );

  if (nonEmptyGroups.length === 0) {
    return (
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Findings</h3>
        <p className={styles.empty}>No findings recorded.</p>
      </section>
    );
  }

  const leftGroups = nonEmptyGroups.filter((_, i) => i % 2 === 0);
  const rightGroups = nonEmptyGroups.filter((_, i) => i % 2 === 1);

  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Findings</h3>
      <div className={styles.columns}>
        <div className={styles.column}>
          {leftGroups.map((group) => (
            <FindingGroup key={group.groupLabel} group={group} />
          ))}
        </div>
        <div className={styles.column}>
          {rightGroups.map((group) => (
            <FindingGroup key={group.groupLabel} group={group} />
          ))}
        </div>
      </div>
    </section>
  );
}
